export default __webpack_public_path__ + "static/media/IMG_0958cropped.7227d9a7.jpeg";